import { NotificationPermissionWidget } from 'open-modules/zdf/feature/account/account-notification-permission';
import { CLICK, component, demoFile, story } from 'system/demo';

demoFile('open-modules/zdf/feature/account/account-notification-permission');

component(
    'NotificationPermissionWidget',
    NotificationPermissionWidget,
    {
        structureKey: 'account',
        features: [
            'notificationpermission',
            'pushnotificationpermission',
            'emailnotificationpermission',
            'emailnotificationreplies',
            'emailnotificationmoderation',
        ],
    },
    [
        story('Toggle push notifications', [CLICK('push-notifications-replies')]),
        story('Toggle email notifications', [CLICK('email-notifications-replies')]),
        story('Toogle email moderation notifications', [CLICK('email-notifications-moderation-decisions')]),
    ],
);
